import reportingEn from '../../../../docs/reporting-setup.md?raw'
import reportingEs from '../../../../docs/reporting-setup.es.md?raw'

// Single source: the guide text lives in docs/, never copied into client/src.
export const getReportingGuide = (language: string) =>
  language.startsWith('es') ? reportingEs : reportingEn

const SECTION_ANCHORS = {
  tra: { en: 'tra-setup', es: 'configuración-de-tra' },
  sire: { en: 'sire-setup', es: 'configuración-de-sire' },
  troubleshooting: { en: 'troubleshooting', es: 'solución-de-problemas' },
} as const

export type ReportingGuideSection = keyof typeof SECTION_ANCHORS

/** In-app path of the guide, anchored to a section in the current language. */
export const reportingGuidePath = (language: string, section?: ReportingGuideSection) => {
  const base = '/help/reporting-setup'
  if (!section) return base
  return `${base}#${SECTION_ANCHORS[section][language.startsWith('es') ? 'es' : 'en']}`
}
